module.exports = __webpack_public_path__ + "img/1大寮站.eccd95aa.jpg";